module.exports = __webpack_public_path__ + "img/a3b2c5b.jpg";